export interface SupportDataItem {
  tipType: string;
  categoryName: string;
}

export const supportData: Record<string, SupportDataItem> = {
  '/org-tree': { tipType: 'orgTree', categoryName: 'communities' },
};
